import {DashboardType} from "../../model/dashboard/types";
import {DashboardConfig} from "../../model/dashboard/dashboard-config";
import {generateUniqueId} from "../../../../gd/utils/misc/generate-unique-id";

export function tasksSummaryDashboardConfig() {


    const widgetsConfig: any = [
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 0,
                "y": 0
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "groupBy": "actionRequiredUserId",
                "includeSubFolders": true,
                "showClosedTasks": false,
                "showPercents": false
            },
            "title": "By Action Required",
            "type": "tasks-summary"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 6,
                "y": 0
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "groupBy": "assignedToUserId",
                "includeSubFolders": true,
                "showClosedTasks": false,
                "showPercents": false
            },
            "title": "By Assignee",
            "type": "tasks-summary"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 12,
                "x": 0,
                "y": 2
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "graphType": "bar",
                "groupBy": "statusId",
                "includeSubFolders": true,
                "includeSubtasks": true,
                "showClosedTasks": false
            },
            "title": "By Status",
            "type": "task-chart"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 0,
                "y": 4
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "graphType": "lollipop",
                "groupBy": "taskTypeId",
                "includeSubFolders": true,
                "includeSubtasks": true,
                "showClosedTasks": false
            },
            "title": "By Task type",
            "type": "task-chart"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 6,
                "y": 4
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "graphType": "donut",
                "groupBy": "priority",
                "includeSubFolders": true,
                "includeSubtasks": true,
                "showClosedTasks": false,
                "showLegend": true
            },
            "title": "By Priority",
            "type": "task-chart"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 0,
                "y": 6
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "reportDate": {
                    "lastDays": 30
                },
                "tasksStatus": "closed"
            },
            "title": "Closed Tasks",
            "type": "line-chart"
        },
        {

            "color": 6,
            "conditions": null,
            "gridPosition": {
                "h": 2,
                "w": 6,
                "x": 6,
                "y": 6
            },
            "id": generateUniqueId(),
            "settings": {
                "counterType": "tasks-total",
                "reportDate": {
                    "lastDays": 30
                },
                "tasksStatus": "open"
            },
            "title": "Open Tasks",
            "type": "line-chart"
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.CUSTOM,
        "widgets"   : widgetsConfig
    }

    return dashboardConfig
}

